export default "__VITE_ASSET__DET8g75O__"